module.exports = __webpack_public_path__ + "img/event-investigation.f00ab4cc.png";